<div class="section-header">
    <mat-icon class="section-icon">add_box</mat-icon>
    <span class="section-title">{{ 'ai.createNewScene' | transloco }}</span>
    <button mat-icon-button class="close-button" (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="stepper-wrapper">
    <app-video-link videoLink="sceneWizard"></app-video-link>

    <div class="stepper-btn">
        @if (selectedStep != 0) {
            <button mat-raised-button color="warn" (click)="stepper.previous()">
                <mat-icon class="hide-lt-sm">skip_previous</mat-icon>
                {{ "general.back" | transloco }}
            </button>
        }
        @if ((sceneType === "blank" && selectedStep != 3) || (sceneType !== "blank" && selectedStep != 4)) {
            <button mat-raised-button color="warn" (click)="stepper.next()">
                <mat-icon class="hide-lt-sm">skip_next</mat-icon>
                {{ "general.next" | transloco }}
            </button>
        }
        @if (upgradable) {
            <button color="primary" mat-raised-button (click)="upgrade()" class="upgrade-button">
                <mat-icon class="hide-lt-sm">rocket_launch</mat-icon>
                {{ "general.upgradeToEnterprise" | transloco }}
            </button>
        }
    </div>
    <mat-horizontal-stepper linear #stepper (selectionChange)="onStepChange($event)">
        <mat-step>
            <ng-template matStepLabel>{{ "general.type" | transloco }}</ng-template>
            <div fxFlex fxLayout="column" class="wizard-type">
                <div class="scene-types">
                    <div class="type-label">
                        @if (sceneType === 'blank') {
                            <mat-icon>done</mat-icon>
                        }
                        <div>basic</div>
                    </div>
                    <div fxFlex fxLayout="row wrap">
                        <div class="scene-type" [ngClass]="{ selected: sceneType === 'blank' }" (click)="selectSceneType('blank', '')">
                            <fa-icon [icon]="faSquare"></fa-icon>
                            <span>{{ "general.blankScene" | transloco }}</span>
                        </div>
                    </div>
                </div>
                <div class="scene-types">
                    <div class="type-label">
                        @if (sceneType === 'component') {
                            <mat-icon>done</mat-icon>
                        }
                        <div>{{ "general.componentScene" | transloco }}</div>
                    </div>
                    <div fxFlex fxLayout="row wrap">
                        <div class="scene-type" [ngClass]="{ selected: typeComponent === 'playlist' }" (click)="selectSceneType('component', 'playlist')">
                            <fa-icon [icon]="componentIcons['playlist']"></fa-icon>
                            <span>{{ "general.playlist" | transloco }}</span>
                        </div>
                        <div class="scene-type" [ngClass]="{ selected: typeComponent === 'collection' }" (click)="selectSceneType('component', 'collection')">
                            <fa-icon [icon]="componentIcons['collection']"></fa-icon>
                            <span>{{ "general.collection" | transloco }}</span>
                        </div>
                        <div class="scene-type" [ngClass]="{ selected: typeComponent === 'scheduler' }" (click)="selectSceneType('component', 'scheduler')">
                            <fa-icon [icon]="componentIcons['scheduler']"></fa-icon>
                            <span>{{ "general.scheduler" | transloco }}</span>
                        </div>
                        <div class="scene-type" [ngClass]="{ selected: typeComponent === 'slide' }" (click)="selectSceneType('component', 'slide')">
                            <mat-icon>slideshow</mat-icon>
                            <span>slide</span>
                        </div>
                    </div>
                </div>
                <div class="scene-types">
                    <div class="type-label">
                        @if (sceneType === 'category') {
                            <mat-icon>done</mat-icon>
                        }
                        <div>{{ "general.specializedScene" | transloco }}</div>
                    </div>
                    <div fxFlex fxLayout="row wrap">
                        @for (jsonType of jsonTypes; track jsonType) {
                            <div class="scene-type" [ngClass]="{ 'selected': typeCategory == jsonType, 'upgrade-required': (!user.enterprise && jsonType.enterprise) }" (click)="selectSceneType('category', jsonType, !user.enterprise && jsonType.enterprise)">
                                <fa-icon [icon]="jsonType.icon"></fa-icon>
                                <span>{{ "mimes." + jsonType.label | transloco }}</span>
                                @if (!user.enterprise && jsonType.enterprise) {
                                    <mat-icon class="enterprise">star</mat-icon>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{ "general.dimensions" | transloco }}</ng-template>
            <div class="step-body-wrapper dimensions" style="margin-left: auto; margin-right: auto">
                <div fxLayout="row" fxFill class="contButtons">
                    <button fxFlex="100%" (click)="go('0')" mat-raised-button>
                        <!-- [color]="sceneStyle == 'horizontal' ? 'primary' : 'basic'" -->
                        <mat-icon class="hide-lt-sm">stay_current_landscape</mat-icon>
                        <span class="switchButtons">{{ "general.horizontal" | transloco }}</span>
                    </button>
                    <button fxFlex="100%" (click)="go('1')" mat-raised-button>
                        <!-- [color]="sceneStyle == 'horizontal' ? 'basic' : 'primary'" -->
                        <mat-icon class="hide-lt-sm">stay_current_portrait</mat-icon>
                        <span class="switchButtons">{{ "general.vertical" | transloco }}</span>
                    </button>
                    <button fxFlex="100%" (click)="go('2')" mat-raised-button>
                        <!-- [color]="sceneStyle == 'horizontal' ? 'basic' : 'primary'" -->
                        <mat-icon class="hide-lt-sm">square_foot</mat-icon>
                        <span class="switchButtons">{{ "general.custom" | transloco }}</span>
                    </button>
                </div>
                <ngx-flicking [options]="{ circular: false, duration: 800, autoResize: true }">
                    <div flicking-panel fxFlex fxLayoutAlign="space-around center" class="flex-lt-sm-col panel">
                        <mat-icon class="dimension-icon">crop_landscape</mat-icon>
                        <div>
                            <mat-radio-group fxLayout="row wrap" fxLayoutGap="16px" class="dimension-radio-group" [(ngModel)]="dimensionIndex">
                                @for (d of hDimensions; track d; let ind = $index) {
                                    <mat-radio-button class="dimension-radio-button" [value]="ind">{{ d }}</mat-radio-button>
                                }
                            </mat-radio-group>
                        </div>
                    </div>
                    <div flicking-panel fxFlex fxLayoutAlign="space-around center" class="panel flex-lt-sm-col">
                        <mat-icon class="dimension-icon">crop_portrait</mat-icon>
                        <div>
                            <mat-radio-group fxLayout="row wrap" fxLayoutGap="16px" class="dimension-radio-group" [(ngModel)]="dimensionIndex">
                                @for (d of vDimensions; track d; let ind = $index) {
                                    <mat-radio-button class="dimension-radio-button" [value]="ind">{{ d }}</mat-radio-button>
                                }
                            </mat-radio-group>
                        </div>
                    </div>

                    <div flicking-panel fxFlex fxLayoutAlign="space-around center" class="flex-lt-sm-col panel">
                        <mat-icon class="dimension-icon">square_foot</mat-icon>
                        <div class="dimension-radio-group">
                            <mat-form-field class="custom-size-field">
                                <mat-label>{{ "general.width" | transloco }}</mat-label>
                                <input inputrestriction="basic1" matInput type="number" max="7680" placeholder="" [(ngModel)]="customSizeX" autocomplete="off" />
                            </mat-form-field>
                            <mat-form-field class="custom-size-field">
                                <mat-label>{{ "general.height" | transloco }}</mat-label>
                                <input inputrestriction="basic1" matInput type="number" max="7680" placeholder="" [(ngModel)]="customSizeY" autocomplete="off" />
                            </mat-form-field>
                        </div>
                    </div>
                </ngx-flicking>
            </div>
        </mat-step>
        @if (sceneType != 'blank' && typeComponent != 'slide') {
        <mat-step>
            <ng-template matStepLabel>{{ "general.content" | transloco }}</ng-template>
            <div class="content-title">{{ "general.specialComponent" | transloco }}</div>
            <div fxLayout="row wrap" fxLayoutAlign="center center" class="step-body-wrapper">
                @for (item of sceneContents; track item; let ind = $index) {
                    <div class="template-scene" [ngClass]="{ selected: ind == templateIndex, horizontal: tabIndex == 0 }" (click)="setTemplate(ind)">
                        @for (coord of item; track coord) {
                            <div
                                class="pattern"
                                [ngStyle]="{
                                    'top.px': coord[0],
                                    'left.px': coord[1],
                                    'width.px': coord[2],
                                    'height.px': coord[3]
                                }"
                            >
                                @if (coord[4] == 1) {
                                    @if (typeComponent) {
                                        <fa-icon [icon]="componentIcons[typeComponent]"></fa-icon>
                                    } @else if (typeCategory) {
                                        <fa-icon [icon]="typeCategory.icon"></fa-icon>
                                    }
                                }
                            </div>
                        }
                    </div>
                }
            </div>
        </mat-step>
        }

        <mat-step>
            <ng-template matStepLabel>{{ "general.animation" | transloco }}</ng-template>
            <div class="step-body-wrapper">
                <div style="padding-left: 20px">
                    <mat-radio-group fxLayout="row">
                        <mat-radio-button (click)="removeAnimationSlice($event)" [checked]="!enableAnimationEngine" value="0">
                            <span>{{ "general.inherit" | transloco }}</span>
                            &nbsp;&nbsp;
                        </mat-radio-button>
                        <mat-radio-button (click)="createAnimationSlice()" [checked]="enableAnimationEngine" value="1">
                            <span>{{ "general.override" | transloco }}</span>
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div style="position: relative">
                    <app-dialog-preset-animation [resetAnimations]="true" [disableUI]="!enableAnimationEngine" (selectAnimation)="presetSceneAnimation($event)"></app-dialog-preset-animation>
                </div>
            </div>
        </mat-step>
        <mat-step>
            <ng-template matStepLabel>{{ "general.complete" | transloco }}</ng-template>
            <form [formGroup]="propertyFormGroup">
                <div fxLayoutAlign="center center" class="step-body-wrapper" fxLayout="column" fxLayoutGap="32px">
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="64px" class="flex-lt-sm-col scene-properties">
                        <div style="min-width: 300px">
                            <table class="table-preview">
                                <tr style="position: relative; top: 5px">
                                    <td class="input-props bt-right">{{ "general.sceneName" | transloco }}*</td>
                                    <td class="input-props">
                                        <mat-form-field>
                                            <input autocomplete="off" type="text" inputrestriction="basic1" matInput formControlName="sceneName" (change)="onChangeSceneName()" required />
                                        </mat-form-field>
                                    </td>
                                </tr>
                                <tr style="position: relative; top: -5px">
                                    <td class="input-props">{{ "general.category" | transloco }}</td>
                                    <td class="input-props">
                                        <app-category-filter [categories]="categories" (updateCategory)="changeSceneCategory($event)" [hideLabel]="true"></app-category-filter>
                                    </td>
                                </tr>
                                @if (sceneType == 'component' && typeComponent === 'scheduler') {
                                    <tr style="position: relative; top: -10px">
                                        <td class="input-props">{{ "general.schedulerName" | transloco }}*</td>
                                        <td class="input-props">
                                            <mat-form-field>
                                                <input inputrestriction="basic1" matInput type="text" placeholder="" formControlName="scheduleName" (change)="onChangeScheduleName()" required />
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                    <tr style="position: relative; top: -10px">
                                        <td class="input-props">{{ "general.description" | transloco }}</td>
                                        <td class="input-props">
                                            <mat-form-field>
                                                <input matInput type="text" placeholder="" formControlName="scheduleDesc" />
                                            </mat-form-field>
                                        </td>
                                    </tr>
                                }
                                @if (sceneType != 'category' && typeComponent != 'slide') {
                                    <tr>
                                        <td>{{ "general.playerAssignable" | transloco }}</td>
                                        <td>
                                            <mat-checkbox style="position: relative; left: -10px" formControlName="playerAssignable"></mat-checkbox>
                                        </td>
                                    </tr>
                                }
                                <tr>
                                    <td>{{ "general.dimension" | transloco }}</td>
                                    <td>
                                        @switch (sceneStyle) {
                                            @case ('vertical') {
                                                <div>{{ vDimensions[dimensionIndex] }} px (vertical)</div>
                                            }
                                            @case ('horizontal') {
                                                <div>{{ hDimensions[dimensionIndex] }} px (horizontal)</div>
                                            }
                                            @case ('custom') {
                                                <div>{{ customSizeX + " x " + customSizeY }} px</div>
                                            }
                                        }
                                    </td>
                                </tr>
                                @if (sceneType == 'blank') {
                                    <tr>
                                        <td>{{ "general.type" | transloco }}</td>
                                        <td>{{ "general.blankScene" | transloco }}</td>
                                    </tr>
                                } @else if (sceneType == 'component') {
                                    <tr>
                                        <td>{{ "general.type" | transloco }}</td>
                                        <td>
                                            @if (typeComponent == 'slide') {
                                                <mat-icon>touch_app</mat-icon>
                                                &nbsp;{{ typeComponent }}
                                            } @else {
                                                <fa-icon [icon]="componentIcons[typeComponent]"></fa-icon>
                                                &nbsp;{{ typeComponent }}
                                            }
                                        </td>
                                    </tr>
                                } @else if (sceneType == 'category' && typeCategory) {
                                    <tr>
                                        <td>{{ "general.type" | transloco }}</td>
                                        <td>
                                            <fa-icon [icon]="typeCategory.icon"></fa-icon>
                                            &nbsp;{{ "general." + typeCategory.label | transloco | StringJSV2Pipe : stringJSPipeArgs }}
                                        </td>
                                    </tr>
                                }
                            </table>
                        </div>
                        @if (sceneType != 'blank' && typeComponent != 'slide') {
                            <div>
                                <div class="template-scene" [ngClass]="{ horizontal: tabIndex == 0 }">
                                    @for (coord of sceneContents[templateIndex]; track coord) {
                                        <div
                                            class="pattern"
                                            [ngStyle]="{
                                                'top.px': coord[0],
                                                'left.px': coord[1],
                                                'width.px': coord[2],
                                                'height.px': coord[3]
                                            }"
                                        >
                                            @if (coord[4] == 1) {
                                                @if (typeComponent) {
                                                    <fa-icon [icon]="componentIcons[typeComponent]"></fa-icon>
                                                } @else if (typeCategory) {
                                                    <fa-icon [icon]="typeCategory.icon"></fa-icon>
                                                }
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                    </div>
                    <div class="d-flex-center">
                        <button mat-raised-button color="primary" (click)="onClose()" mat-button style="margin-right: 20px">
                            {{ "general.cancel" | transloco }}
                        </button>
                        <button mat-raised-button color="warn" (click)="createScene()" [disabled]="disableCreate">
                            <mat-icon>control_camera</mat-icon>
                            {{ "general.newScene" | transloco }}
                        </button>
                    </div>
                </div>
            </form>
        </mat-step>
    </mat-horizontal-stepper>
</div>
